import React from 'react';

import Chevron from 'components/Icons/Chevron';

export default props => <Chevron direction="forward" {...props} />;
